import { displayGroupings, settingsPreferences } from '../../util/uiconstants';
import { useHistory, withRouter } from 'react-router-dom';

import Button from '@ey/motif-react-wrapper/Button';
import MotifButtonGroup from '@ey/motif-react-wrapper/ButtonGroup';
import React from 'react';
import { labels } from '../../util/uiconstants';
import { parse } from 'query-string';
import styled from 'styled-components';
import { updateGroupPrefUserSettings } from '../../actions/usersettingsaction';
import { useDispatch } from 'react-redux';
import ContentSwitcher from '@ey/motif-react-wrapper/ContentSwitcher';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {
	IconoirList,
	IconoirRubikCube
} from '@ey-xd/motif-icon';
import { adobeAnalytics } from '@ey/voltron-analytics';
import { clickActionArgs } from '../Common/Adobe Analytics/actionHelpers.js';
import {
	eventTypes,
	controlTypes,
	locationInPages,
	clickActionNames,
} from '../Common/Adobe Analytics/constants.js';

const Toplevelcss = styled.div`
	float: right;
	margin-top: calc(var(--px-6) * -1);
	.motif-content-switcher {
		background-color: var(--neutrals-100) !important;
		border-color: var(--neutrals-200);
	}
	.motif-button.btn-active {
		box-shadow: var(--btn-primary--box-shadow) !important;
		border-color: var(--btn-primary--border-color) !important;
		border-width: var(--btn-primary--border-width) !important;
		border-style: var(--btn-primary--border-style) !important;
	}
`;

const EngagementGrouping = (props) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const trackEvent = adobeAnalytics.useAdobeAnalyticsTrack();

	const { location } = props;

	const displayGrouping = () => {
		const params = parse(location.search);
		return params.groupby ? displayGroupings.MODULE : displayGroupings.LIST;
	};

	let dynClassList =
		'' + displayGrouping() === displayGroupings.LIST
			? 'btn-active'
			: '';
	let dynClassModule =
		'' + displayGrouping() === displayGroupings.MODULE
			? 'btn-active'
			: '';

	let dynVariantList =
		'' + displayGrouping() === displayGroupings.LIST
			? 'primary'
			: 'secondary';
	let dynVariantModule =
		'' + displayGrouping() === displayGroupings.MODULE
			? 'primary'
			: 'secondary';

	const updateGroupPreferenceUserSettings = (settingPreference) => {
		dispatch(updateGroupPrefUserSettings(settingPreference));
		const searchParams = settingPreference == 'engagements' ? '' : '?groupby=clients';
		history.push({
			pathname: history.location.pathname,
			search: searchParams,
		});
		props.resetPager();

		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				`${settingPreference} ${clickActionNames.horizontalNavSuffix}`,
				controlTypes.icon,
				locationInPages.horizontalNav,
				`${window.location.origin}${history.location.pathname}${searchParams}`,
			));
	};

	return (
		<Toplevelcss className="workspaces_view">
			<MotifButtonGroup>
				<Button
					className={dynClassList}
					name="view_list"
					variant={dynVariantList}
					onClick={(e) => {
						updateGroupPreferenceUserSettings(settingsPreferences.EngagementList);
					}}
					children={<MotifIcon src={IconoirList} title={labels.engagementslist}/>}
				>
				</Button>
				<Button
					className={dynClassModule}
					name="view_module"
					variant={dynVariantModule}
					onClick={(e) => {
						updateGroupPreferenceUserSettings(settingsPreferences.WorkspaceList);
					}}
					children={<MotifIcon src={IconoirRubikCube} title={labels.workspacelist}/>}
				>
				</Button>
			</MotifButtonGroup>
		</Toplevelcss>
	);
};

export default withRouter(EngagementGrouping);
